import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/icon-user-card.svg'


const _hoisted_1 = { class: "user-test-wrapper start-test" }
const _hoisted_2 = { class: "user-card" }
const _hoisted_3 = { class: "user-card__header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "user-card__img",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = { class: "user-card__caption" }
const _hoisted_6 = ["innerHTML"]

import UserApi from "@/api/UserApi";
import { useTestStore } from "@/store/UserTestModule";
import { onMounted, ref } from "vue";
import ITest from "../interfaces/ITest";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'StartTestComponent',
  setup(__props) {

const api = new UserApi();
const testStore = useTestStore();
const testInfo = ref({} as ITest);

function goToTest() {
  testStore.setQuestions(testInfo.value.questionForUsers);
  router.push({ name: "test" });
}

async function loadTest() {
  await api.loadTest(testStore.testId).then((res) => {
    testInfo.value = res;
  });
}

onMounted(() => {
  loadTest();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("h1", _hoisted_5, " Добро пожаловать в тест “" + _toDisplayString(testInfo.value.name) + "”! ", 1)
      ]),
      _createElementVNode("div", {
        class: "user-card__description",
        innerHTML: testInfo.value.description
      }, null, 8, _hoisted_6),
      _createElementVNode("button", {
        class: "base-btn base-btn-yellow user-card__start-test-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (goToTest()))
      }, " Пройти тест ")
    ])
  ]))
}
}

})